import { render, staticRenderFns } from "./DashboardSaleRanking.vue?vue&type=template&id=0bdfbfcb&scoped=true&"
import script from "./DashboardSaleRanking.vue?vue&type=script&lang=ts&"
export * from "./DashboardSaleRanking.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSaleRanking.vue?vue&type=style&index=0&id=0bdfbfcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdfbfcb",
  null
  
)

export default component.exports